/* RESPONSIBLE TEAM: team-inbox-management */
import Service, { inject as service } from '@ember/service';
import type InboxApi from './inbox-api';
import type Session from './session';

export default class PinnedColumnsService extends Service {
  @service declare inboxApi: InboxApi;
  @service declare session: Session;

  async updateViewPinnedColumns(
    viewId: string,
    addedColumns: string[],
    removedColumns: string[],
  ): Promise<string[]> {
    return await this.inboxApi.updateViewPinnedColumns(viewId, addedColumns, removedColumns);
  }

  mergeColumnsWithPinned(userSelectedColumns: string[], pinnedColumns: string[] = []): string[] {
    let pinnedSet = new Set(pinnedColumns);
    let foundPinned = new Set<string>();
    let result: string[] = [];
    for (let col of userSelectedColumns) {
      result.push(col);
      if (pinnedSet.has(col)) {
        foundPinned.add(col);
      }
    }
    for (let i = pinnedColumns.length - 1; i >= 0; i--) {
      let col = pinnedColumns[i];
      if (!foundPinned.has(col)) {
        result.unshift(col);
      }
    }
    return result;
  }
}
